import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Shield, Trash2, LogOut, Info, Database } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { store, defaultData } from "@/lib/storage";
import { faq } from "@/data/roadmap";
import { Button } from "@/components/ui/button";
import { SectionTitle } from "@/components/common";

export default function Settings() {
  const { user, logout, updateData, data } = useApp();
  const navigate = useNavigate();

  const resetData = () => {
    updateData(() => ({ ...defaultData(), profile: { ...defaultData().profile, name: user.name }, onboardingComplete: true }));
    toast.success("Data aplikasi direset.");
  };
  const exportData = () => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "scholavia-data.json"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6">
      <SectionTitle title="Pengaturan" desc="Kelola akun & data lokalmu." />

      <div className="rounded-2xl border border-purple-100 bg-white p-5 shadow-sm">
        <h3 className="font-display text-base font-bold text-slate-900">Akun</h3>
        <div className="mt-3 space-y-1 text-sm text-slate-600">
          <p><span className="text-slate-400">Nama:</span> {user?.name}</p>
          <p><span className="text-slate-400">Email:</span> {user?.email}</p>
        </div>
        <div className="mt-4 flex flex-wrap gap-2">
          <Button variant="outline" onClick={() => navigate("/app/profil")} className="rounded-full border-purple-200 text-[#5B21B6]">Edit Profil</Button>
          <Button variant="outline" onClick={() => { logout(); navigate("/"); }} data-testid="settings-logout" className="rounded-full border-red-200 text-red-600 hover:bg-red-50"><LogOut className="mr-1.5 h-4 w-4" /> Keluar</Button>
        </div>
      </div>

      <div className="rounded-2xl border border-purple-100 bg-white p-5 shadow-sm">
        <h3 className="flex items-center gap-2 font-display text-base font-bold text-slate-900"><Database className="h-4 w-4 text-[#7C3AED]" /> Data & Privasi</h3>
        <p className="mt-2 text-sm text-slate-500">Semua data profil, tes, roadmap, dan preferensi disimpan lokal di browsermu (localStorage). Tidak ada yang dikirim ke server.</p>
        <div className="mt-4 flex flex-wrap gap-2">
          <Button variant="outline" onClick={exportData} className="rounded-full border-purple-200 text-[#5B21B6]">Ekspor Data (JSON)</Button>
          <Button variant="outline" onClick={resetData} data-testid="settings-reset" className="rounded-full border-red-200 text-red-600 hover:bg-red-50"><Trash2 className="mr-1.5 h-4 w-4" /> Reset Data Aplikasi</Button>
        </div>
      </div>

      <div className="rounded-2xl border border-purple-100 bg-white p-5 shadow-sm">
        <h3 className="flex items-center gap-2 font-display text-base font-bold text-slate-900"><Info className="h-4 w-4 text-[#7C3AED]" /> FAQ</h3>
        <div className="mt-3 space-y-3">
          {faq.map((f) => (
            <div key={f.q} className="rounded-xl bg-[#FBFAFF] p-3">
              <p className="text-sm font-semibold text-slate-700">{f.q}</p>
              <p className="mt-0.5 text-sm text-slate-500">{f.a}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-start gap-2 rounded-xl border border-purple-100 bg-purple-50/50 p-4 text-xs text-slate-500">
        <Shield className="mt-0.5 h-4 w-4 text-[#7C3AED]" />
        <span>Scholavia adalah alat persiapan. Skor readiness & match adalah diagnostik, bukan jaminan penerimaan, visa, atau hasil apa pun.</span>
      </div>
    </div>
  );
}
